import CompanyProfileForm from "./company-profile-form";
import AboutCompanyForm from "./about-company-form";

const forms = {
    CompanyProfileForm,
    AboutCompanyForm
};

export default forms;